import { getIn, useFormikContext } from 'formik';
import React, { FC } from 'react';
import FormikField from '../../FormikField';
import { FormFieldToggleButtonProps } from '../FormFieldToggleButton';
import * as SC from './styled';
export type FormFieldToggleButtonGroupProps = {
  className?: string;
  label?: string;
  subtitle?: string;
  name: string;
  options: Array<Omit<FormFieldToggleButtonProps, 'name'>>;
  required?: boolean;
  disabled?: boolean;
  pastille?: boolean;
  limit?: number;
  asImage?: boolean;
  asSubtitle?: boolean;
};
const FormFieldToggleButtonGroup: FC<FormFieldToggleButtonGroupProps> = ({
  className,
  pastille,
  disabled,
  required,
  name,
  options,
  label,
  subtitle,
  limit
}) => {
  const {
    values
  } = useFormikContext();
  const activeValues = getIn(values, name);
  return <SC.Wrapper className={className} $isDisabled={disabled}>
      <SC.Header>
        {label && <SC.Label required={required}>{label}</SC.Label>}
        {subtitle && <SC.Subtitle>{subtitle}</SC.Subtitle>}
      </SC.Header>
      <SC.Options $asImage={options[0].image ? true : false} $asSubtitle={options[0].subtitle ? true : false}>
        {options.map(option => {
        const order = activeValues?.findIndex((t: string) => t === option.value);
        return <SC.ButtonContainer key={`toggle-option-${option.value}`}>
              {pastille && order >= 0 && <SC.Pastille $asImage={option.image ? true : false}>
                  {order + 1}
                </SC.Pastille>}
              <FormikField {...option} name={name} type="checkbox" Component={SC.Checkbox} showError={false} isGroupChild disabled={option.disabled || limit && activeValues && activeValues.length >= limit && !activeValues.includes(option.value)} icon={option.icon && option.icon} image={option.image && option.image} subtitle={option.subtitle && option.subtitle} />
            </SC.ButtonContainer>;
      })}
      </SC.Options>
    </SC.Wrapper>;
};
export default FormFieldToggleButtonGroup;